import React, { useState, useEffect, useContext, useRef } from "react";
import Avatar from 'react-avatar';
import {
	getOrganizerDetails,
	deleteNewOrganizer,
	postNewOrganizerDetails
} from "../../revampCRUD/organisers.crud";
import { useParams } from "react-router-dom";
import LoadingSpinner from "../../revampComponents/Atom/Loading";
import DeleteModal from "../../revampComponents/Atom/Modals/DeleteModal";
import TileCard from "../../revampComponents/Atom/Cards/TileCard";
import { KonfhubButton } from "../../revampComponents/Atom/Buttons";
import InfoBackground from "../../revampComponents/Atom/Backgrounds/InfoBackground";
import { useFormik } from "formik";
import { errorToaster, successToaster, regexMethods, fetchValueForRoleId } from "../../reusable/common";
import * as yup from "yup";
import AuthContext from "../../contexts/AuthContext";
import { ReactComponent as TransferIcon } from "../../assets/Transfer-icon.svg";
import TippyIcon from "../../revampComponents/Atom/TippyIcon";
import TransferOwnership from "./TransferOwnership";
import EditRole from "./EditRole";
import CautionImage from "../../assets/Caution.svg";
import { debounce } from "lodash";
import { checkPotentialDomainTypo } from "../../Utils/helpers";
import CustomDropdown from "../../revampComponents/Atom/CustomDropdown";
import EmailNotification from "./EmailNotification";
import Dropdown from "../../revampComponents/Atom/Dropdown";
import { SuperAdmins } from "../../config/SuperAdmins";
import KonfhubIcon from "../../assets/img/konfhub-icon.svg";
import { dashboardColors, theme } from "../../themes/Theme";
import { addProfileOrganizer, deleteProfileOrganizer, getProfileOrganizer } from "../../revampCRUD/EventProfile/team.curd";

const TeamPage = (props) => {
	const [organizerDetails, setOrganizerDetails] = useState(null);
	const { eventId } = useParams();
	const [deleteModal, setDeleteModal] = useState(false);
	const [organizerUser, setOrganizerUser] = useState();
	const [listOfEvents, setListOfEvents] = useState({
		new_user_email: "",
		role_id: ""
	});
	const [openTransferOwner, setOpenTransferOwner] = useState(false);
	const [editRole, setEditRole] = useState(false);
	const [adminData, setAdminData] = useState(false);

	const [dropdownVisible, setDropdownVisible] = useState(null);
	const [dropdownOpen, setDropdownOpen] = useState(false);

	const [emailNotification, setEmailNotification] = useState(false);
	const [notificationDetails, setNotificationDetails] = useState()

	const { user } = useContext(AuthContext);
	const [loadPage, setLoadPage] = useState(false);

	const customUserId = props?.user?.attributes["custom:userId"];

	const { module, profileId } = props;


	const isEventProfile = module === "event-profile";

	// get Organizers list
	const listOrganizerDetails = async () => {
		setLoadPage(true)
		try {
			const getResponse = await getOrganizerDetails(eventId);
			if (getResponse.status === 200) {
				setOrganizerDetails(getResponse.data);
				setLoadPage(false)
			} else {
				errorToaster("Something went wrong");
				setLoadPage(false)
			}
		} catch (err) {
			errorToaster("Something went wrong");
			setLoadPage(false)
		}
	};

	const listProfileOrganizerDetails = async () => {
		setLoadPage(true)
		try {
			const getResponse = await getProfileOrganizer(profileId);
			if (getResponse.status === 200) {
				setOrganizerDetails(getResponse?.data?.profile_organisers);
				setLoadPage(false)
			} else {
				errorToaster("Something went wrong");
				setLoadPage(false)
			}
		} catch (err) {
			errorToaster("Something went wrong");
			setLoadPage(false)
		}
	};

	useEffect(() => {
		if (isEventProfile) {
			listProfileOrganizerDetails()
		} else listOrganizerDetails();
	}, []);


	const refreshList = isEventProfile ? listProfileOrganizerDetails : listOrganizerDetails;


	const formik = useFormik({
		enableReinitialize: true,
		initialValues: listOfEvents,
		validationSchema: yup.object({
			new_user_email: yup
				.string()
				.required("Please enter email")
				.test(
					'is-mistake',
					'Please enter a valid email (there might be a typo in the email domain)',
					(value, context) => checkPotentialDomainTypo(value) ? false : true,
				)
				.email("Please enter a valid email"),
			role_id: yup.number()
				.required("Please select role")
		}),
		onSubmit: async (values, submitProps) => {
			values.new_user_email = values?.new_user_email?.toLowerCase();

			try {
				let response;

				if (isEventProfile) {
					response = await addProfileOrganizer(
						profileId,
						values,
					);
				} else {
					response = await postNewOrganizerDetails(
						eventId,
						values,
						user.signInUserSession.accessToken.jwtToken,
						user.signInUserSession.idToken.jwtToken
					);
				}

				if (response.status === 201) {
					successToaster("New Organizer added successfully");
					formik.values.new_user_email = ""
					formik.values.role_id = ""
					refreshList()
				}
			} catch (err) {
				const errorMessage = err?.response?.data?.error || "Something went wrong";
				errorToaster(errorMessage);
			}
		}
	});


	const provideAccess = async () => {
		const userValues = {
			role_id: 2,
			new_user_email: "reachus@konfhub.com"
		}
		try {
			let response;
			if (isEventProfile) {
				response = await addProfileOrganizer(profileId, userValues)
			} else {
				response = await postNewOrganizerDetails(eventId, userValues);
			}
			if (response.status == 201) {
				successToaster("New Organizer added successfully");
				refreshList();
			} else {
				errorToaster("Something went wrong");
			}
		} catch (err) {
			const errorMessage = err?.response?.data?.error || "Something went wrong";
			errorToaster(errorMessage);
		}
	}

	//delete organizer function
	const deleteOrganizer = async (email_id) => {
		try {
			const newOrganizerDetails = organizerDetails.filter(
				organizer => organizer?.organiser_email !== email_id
			);
			if (isEventProfile) {
				await deleteProfileOrganizer(profileId, email_id);
			} else {
				await deleteNewOrganizer(eventId, email_id);
			}
			successToaster("Organizer deleted successfully");
			setOrganizerDetails(newOrganizerDetails);
		} catch (err) {
			const errorMessage = err?.response?.data?.error || "Something went wrong";
			errorToaster(errorMessage);
		}
	};

	const toggleDropdown = (userId) => {
		setDropdownOpen(true)
		setDropdownVisible(dropdownVisible === userId ? null : userId);
	};

	const handleEmailNotificationPreference = (organizerDetails) => {
		setEmailNotification(true)
		setNotificationDetails(organizerDetails)
	};

	const handleDelete = (email) => {
		setDeleteModal(true);
		setOrganizerUser(email);
	};

	const handleRole = (selectedData) => {
		setEditRole(true);
		setAdminData(selectedData);
	}

	const dropdownItems = (organizer) => {
		const items = [];
		const isNotSelf = organizer?.organiser_email !== user.attributes.email;
		const isAdmin = organizer?.role_id === 2;
		const isAdminNoDownload = organizer?.role_id === 4;
		const currentUserIsEventCreatorOrAdmin = props?.eventInfo?.organiser_role_id === 1 || props?.eventInfo?.organiser_role_id === 2;
		const currentUserIsAdminNoDownload = props?.eventInfo?.organiser_role_id === 4;
		const useSignedUp = organizer?.user_id !== null;

		if (organizer.user_id == customUserId) {
			items.push({
				name: 'Email Notification Preference',
				action: 'emailNotificationPreference',
				icon: <i className="fa fa-gear" style={{ fontSize: "20px", color: dashboardColors[theme].primaryTextColor }}></i>
			});
		}

		//If the selected person is not you
		if (isNotSelf) {
			// If the selected person is admin(No downloads) or admin and you are the event creator or admin
			if ((isAdminNoDownload || isAdmin) && (currentUserIsEventCreatorOrAdmin)) {
				items.push(
					{
						name: 'Edit Role',
						action: 'edit',
						icon: <i className="fas fa-pen" style={{ fontSize: "14px", color: dashboardColors[theme].primary }}></i>
					}
				);
			}

			// If the selected person is admin and you are not admin(No downloads) or the selected person is admin(No downloads), then display delete
			if (isAdmin && !currentUserIsAdminNoDownload || isAdminNoDownload) {
				items.push({
					name: 'Delete',
					action: 'delete',
					icon: <i className="fa fa-trash" style={{ fontSize: "20px", color: "#DC3545" }}></i>
				})
			}
		}

		if (organizer?.user_id == customUserId && organizer?.role_id === 1 && organizerDetails?.length > 1) {
			items.push({
				name: 'Transfer Ownership',
				action: 'transferOwner',
				icon: <TransferIcon style={{ width: '20px', height: '20px' }} />
			});
		}

		return items;
	};

	return (
		<>
			<DeleteModal
				openModal={deleteModal}
				setOpenModal={setDeleteModal}
				item="Delete Organizer"
				text={`Are you sure you want to delete <br />
                the organizer?`}
				onCancel={() => setDeleteModal(false)}
				onOkay={() => {
					setDeleteModal(false);
					deleteOrganizer(organizerUser);
				}}
			/>
			{openTransferOwner &&
				<TransferOwnership
					openTransferOwner={openTransferOwner}
					setOpenTransferOwner={setOpenTransferOwner}
					organizerDetails={organizerDetails}
					eventId={eventId}
					listOrganizerDetails={listOrganizerDetails}
				/>
			}
			{emailNotification &&
				<EmailNotification
					emailNotification={emailNotification}
					setEmailNotification={setEmailNotification}
					notificationDetails={notificationDetails}
					eventId={eventId}
					listOrganizerDetails={listOrganizerDetails}
				/>
			}
			{
				editRole &&
				<EditRole
					editRole={editRole}
					setEditRole={setEditRole}
					organizerDetails={organizerDetails}
					eventId={eventId}
					adminData={adminData}
					listOrganizerDetails={listOrganizerDetails}
				/>
			}
			<div className="row">
				<div className="col-12 col-md-7">
					{loadPage ? <LoadingSpinner /> : organizerDetails != null ? (
						<>
							{organizerDetails?.map((organizer) => (
								<TileCard className="d-flex justify-content-between mb-3 align-items-center flex-column flex-md-row" key={organizer.organiser_email}>
									<div className="d-flex align-items-center mr-3" style={{ flex: "2" }}>
										{organizer?.organiser_image_url ?
											<img
												src={organizer?.organiser_image_url}
												className="organiserTeam-image"
												style={{ marginRight: "16px" }}
											/> :
											<Avatar
												name={organizer.organiser_name ?? ""}
												round={true}
												textSizeRatio={2}
												size={56}
												color="#002E6E"
												maxInitials={1}
												style={{ marginRight: "16px" }}
											/>
										}
										<div className="pr-3 break-word">
											<p className="m-0" style={{ color: dashboardColors[theme].primaryTextColor, fontWeight: "600" }}>
												{organizer?.organiser_name}
												{organizer?.user_id == null &&
													<TippyIcon
														placement="bottom"
														content={`User not signed-up`}
													>
														<img className="caution_img" src={CautionImage} alt="caution_img" />
													</TippyIcon>}
											</p>
											<p className="m-0 break-word" style={{ color: dashboardColors[theme].primaryTextColor, fontWeight: "400" }}>{organizer?.organiser_email}</p>
											<div className="role-mobile-display">
												{fetchValueForRoleId(organizer.role_id, isEventProfile)?.label}
											</div>
										</div>
									</div>
									<div className="organizerType d-flex justify-content-between mt-2 mt-md-0" style={{ flex: "1" }}>
										<div className="role-display">
											{fetchValueForRoleId(organizer?.role_id, isEventProfile)?.label}
										</div>
										<div className="teams-dropdown-icon">
											{dropdownItems(organizer).length > 0 && (
												<i className="fa fa-ellipsis-v ellipsis" style={{ color: dashboardColors[theme].primaryTextColor }} onClick={() => toggleDropdown(organizer?.organiser_email)}></i>
											)}
											{dropdownOpen && dropdownVisible === organizer?.organiser_email && (
												<CustomDropdown
													open={dropdownOpen && dropdownVisible === organizer?.organiser_email}
													noData="No options available"
													setOpenDropdown={setDropdownVisible}
													onChange={(action) => {
														if (action.action === "emailNotificationPreference") {
															handleEmailNotificationPreference(organizer);
														} else if (action.action === "delete") {
															handleDelete(organizer.organiser_email);
														} else if (action.action === "transferOwner") {
															setOpenTransferOwner(true)
														}
														else if (action.action === "edit") {
															handleRole(organizer);
														}
													}}
													filterValue={dropdownItems(organizer)}
													marginRight="-20px"
												/>
											)}
										</div>
									</div>
								</TileCard>
							))
							}
							{!organizerDetails.some(organizer => organizer?.organiser_email === "reachus@konfhub.com") && (
								<TileCard className="d-flex justify-content-between mb-3 align-items-center flex-column flex-md-row">
									<div className="d-flex align-items-center mr-3" style={{ flex: "2" }}>
										<img
											src={KonfhubIcon}
											className="organiserTeam-image"
											style={{ marginRight: "16px" }}
										/>
										<div className="pr-3">
											<p className="m-0" style={{ color: dashboardColors[theme].primaryTextColor, fontWeight: "600" }}>
												KonfHub Support Team
											</p>
											<p className="m-0" style={{ color: dashboardColors[theme].primaryTextColor, fontWeight: "400" }}>reachus@konfhub.com</p>
											<div className="role-mobile-display">
												admin
											</div>
										</div>
									</div>
									<div className="organizerType d-flex justify-content-end mt-2 mt-md-0" style={{ flex: "1" }}>
										<TippyIcon
											placement="bottom"
											content={`By adding this email, KonfHub support team will be able to access the event when helping with any challenges you may have.`}
										>
											<span>

												<KonfhubButton
													className="mr-0 mr-sm-3 mt-3 mt-sm-0"
													btnType="secondary"
													onClick={() => {
														provideAccess();
													}}
												>
													Provide Access
												</KonfhubButton>
											</span>
										</TippyIcon>
									</div>
								</TileCard>
							)}
						</>

					) : (
						<p className="text-center m-5">No Team Member Added</p>
					)}
				</div>
				<div className="col-12 col-md-5">
					<TileCard border="1px solid #002E6E">
						{isEventProfile ? <h5 className="event-profile-team-add-team-header">
							Add Team Member under Event Profile
						</h5> :
							<h5 style={{ fontSize: "20px", color: dashboardColors[theme].primaryTextColor }}>Add Organizer</h5>
						}
						{isEventProfile ? <p className="event-profile-team-add-team-textOne">
							Team members added to an event profile will also be added to all events linked to that profile
						</p> :
							<p style={{ color: dashboardColors[theme].primaryTextColor }}>
								To add a new organizer with the admin role to the event, please provide their email address.
							</p>}
						<label style={{ color: dashboardColors[theme].primaryTextColor, fontWeight: "500" }}>Email Id <span className="text-danger">*</span></label>
						<input
							style={{ ...((formik.errors.new_user_email && formik.touched.new_user_email && formik.values.new_user_email) && { border: "1px solid red" }) }}
							className="mb-3 input"
							id="new_user_email"
							type="text"
							placeholder="Enter Email Id"
							onKeyPress={e => regexMethods.noSpaces(e)}
							value={formik.values.new_user_email}
							onChange={formik.handleChange}
							onBlur={formik.handleBlur}
						/>
						{(formik.errors.new_user_email && formik.touched.new_user_email && formik.values.new_user_email) && (
							<p className="text-danger mt-0 mb-2">
								{formik.errors.new_user_email}
							</p>
						)}
						<label style={{ color: dashboardColors[theme].primaryTextColor, fontWeight: "500" }} htmlFor="role">
							Role
							<span className="text-danger" style={{ fontWeight: 500 }}> *</span>
						</label>
						<Dropdown
							options={
								props?.eventInfo?.organiser_role_id === 4 ? [{
									label: "Admin (No Downloads)",
									value: 4
								}] : [
									{
										label: "Admin",
										value: 2
									},
									{
										label: "Admin (No Downloads)",
										value: 4
									}
								]}
							id="role"
							className="mb-3"
							defaultValue={fetchValueForRoleId(formik.values?.role_id)}
							value={fetchValueForRoleId(formik.values?.role_id)}
							onChange={e => {
								if (e.value == 2)
									formik.setFieldValue("role_id", 2);
								else if (e.value === 4) {
									formik.setFieldValue("role_id", 4);
								}
							}}
						/>
						{(formik.errors.role_id && formik.touched.role_id && formik.values.role_id === "") && (
							<p className="text-danger mt-0 mb-2">
								{formik.errors.role_id}
							</p>
						)}
						<KonfhubButton
							className="w-100 mb-2"
							onClick={debounce(() => {
								formik.submitForm();
							}, 500)}
							isLoading={formik.isSubmitting}
							disabled={formik.values.new_user_email == "" || formik.values.role_id == "" || formik.isSubmitting}
						>
							<i className="fas fa-paper-plane mr-2"></i>
							Send Email
						</KonfhubButton>
						<InfoBackground>
							{!isEventProfile && <><p className="mb-1 headerInfo-team-add">Event Creator:</p>
								<p className="mb-3">Has read & edit access for the entire event.</p></>}

							<p className="mb-1 headerInfo-team-add">Admin:</p>
							<p className="mb-3">
								{isEventProfile ? "Has read & edit access for all of the sections except Event Bank Details." :
									"Has read & edit access for all of the sections except Bank Details."}
							</p>

							<p className="mb-1 headerInfo-team-add">Admin (No Downloads):</p>
							<p className="mb-0">
								{isEventProfile ? "Has read & edit access for all sections except Event Bank Details. Additionally, this role cannot download attendee data." :
									"Has read & edit access for all sections except Bank Details. Additionally, this role cannot download attendee data."}
							</p>
						</InfoBackground>
					</TileCard>
				</div>
			</div>
			<style>{`
			.organiserTeam-image {
				width: 56px;
				height: 56px;
				border-radius: 100%;
			}
			.headerInfo-team-add {
				font-weight: 500;
				text-decoration: underline;
			}
			.caution_img{
				margin-left: 10px;
				margin-top: -6px;
			}
			.ellipsis{
				cursor: pointer;
				padding-bottom: 5px; 
			}
			.break-word{
				word-break: break-all;
			}
			@media (max-width: 767px){
				.teams-dropdown-icon{
					position: absolute;
					top:10px;
					right:20px;
				}
				.role-display{
						display:none;
					}
			}
			@media (min-width: 767px){
				.teams-dropdown-icon{
					position: relative;
				}
					.role-mobile-display{
						display:none;
					}
			}


			//event profile

			.event-profile-team-add-team-header{
				font-family: Hind;
				font-weight: 500;
				font-size: 16px;
				line-height: 100%;
				color: #1E1F24;
			}
			.event-profile-team-add-team-textOne{
				font-family: Hind;
				font-weight: 400;
				font-size: 14px;
				color: #1E1F24;
			}
			
			`}</style>
		</>
	);
};

export default TeamPage;
